import type { Evidence } from "../types";

/**
 * Whether Al Noor has said something about this child's work since the parent
 * last looked.
 *
 * Reviews were written (review_status, coach_feedback, reviewed_at) but no
 * parent screen ever showed them, so the one person the feedback was for never
 * saw it. "Seen" is per device on purpose: it only decides whether a dot is
 * shown, and a family reading on two phones seeing the dot twice costs nothing.
 */
export function hasNewFeedback(evidence: Evidence[], lastSeen: string | null): boolean {
  return evidence.some((item) => isNewFeedback(item, lastSeen));
}

export function isNewFeedback(item: Evidence, lastSeen: string | null): boolean {
  if (!item.reviewed_at) return false;
  const said = Boolean(item.coach_feedback?.trim()) || item.review_status !== "pending";
  return said && (!lastSeen || item.reviewed_at > lastSeen);
}

const key = (userId: string, learnerId: string) => `hs-feedback-seen:${userId}:${learnerId}`;

export function readFeedbackSeen(userId: string | undefined, learnerId: string | undefined): string | null {
  if (!userId || !learnerId) return null;
  try { return localStorage.getItem(key(userId, learnerId)); } catch { return null; }
}

export function writeFeedbackSeen(userId: string, learnerId: string, when = new Date().toISOString()) {
  try { localStorage.setItem(key(userId, learnerId), when); } catch { /* Storage is optional. */ }
}
